import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="overlay">
        <h1>🚧 We’re Launching Soon 🚧</h1>
        <p>Building something analytical, sleek, and professional.</p>
        <p>Stay tuned for updates.</p>
      </div>
    </div>
  );
}

export default App;
